import { ICasoCobrancaFilaAtendimentoPorGrupoProcedure } from "../../../Interfaces/Cobranca/FilaAtendimento/FilaAtendimentoInterface";
import {
    CarregarDistribuicaoService,
    GetAcaoFilaServices,
    GetCasoCobrancaFilaAtendimentoPorGrupoService,
    GetProximoAtendimentoService,
    ListarCasoCobrancaFilaAtendimentoDetalhadoPorGrupoService,
    ListarCasoCobrancaFilaAtendimentoPorGrupoService,
    ListarProdutosEmAtendimentoDeFilaService,
} from "../../../Services/Cobranca/FilaAtendimento/FilaAtendimentoService";
import { ValidationErr } from "../../../Validations/ValidationError";
import { Controller } from "../../Controller";

export async function CarregarDistribuicaoController() {
    return Controller(CarregarDistribuicaoService());
}

export async function GetProximoAtendimentoController(
    idGrupo: number,
    idCampanha: number
) {
    return Controller(GetProximoAtendimentoService(idGrupo, idCampanha));
}

export async function ListarCasoCobrancaFilaAtendimentoPorGrupoController(
    idGrupo: number,
    idCampanha: number
) {
    const response = await ListarCasoCobrancaFilaAtendimentoPorGrupoService(
        idGrupo,
        idCampanha,
        0
    )
        .then((response) => {
            return response.data as Array<ICasoCobrancaFilaAtendimentoPorGrupoProcedure>;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });

    return response;
}

export async function ExportarExcelFilaAtendimentosCobrancaController(
    idGrupo: number,
    idCampanha: number
) {
    const response = await ListarCasoCobrancaFilaAtendimentoPorGrupoService(
        idGrupo,
        idCampanha,
        1
    )
        .then((response) => {
            return response.data as Blob;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });

    return response;
}

export async function ListarCasoCobrancaFilaAtendimentoDetalhadoPorGrupoController(
    idGrupo: number,
    idCampanha: number
) {
    return Controller(
        ListarCasoCobrancaFilaAtendimentoDetalhadoPorGrupoService(
            idGrupo,
            idCampanha
        )
    );
}

export async function GetCasoCobrancaFilaAtendimentoPorGrupoController(
    idGrupo: number,
    idCampanha: number
) {
    return Controller(
        GetCasoCobrancaFilaAtendimentoPorGrupoService(idGrupo, idCampanha)
    );
}

export async function GetAcaoFilaController(idGrupo: number) {
    return Controller(GetAcaoFilaServices(idGrupo));
}

export async function ListarProdutosEmAtendimentoDeFilaController(
    ID_CASO: number
) {
    return Controller(ListarProdutosEmAtendimentoDeFilaService(ID_CASO));
}
